import { render, staticRenderFns } from "./FactorDescriptionEdit.vue?vue&type=template&id=2109b099&"
import script from "./FactorDescriptionEdit.vue?vue&type=script&lang=js&"
export * from "./FactorDescriptionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports